import { Row, Divider } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import get from "lodash/get";
import slice from "lodash/slice";
import round from "lodash/round";
import sortBy from "lodash/sortBy";

import GraphGrid from "../graphGrid";
import GraphHeader from "./graphHeader";


import { getTransformedMinutes } from "../../../utilities/helpers";
import { fetchScopeNodeHierarchy } from "../../../redux/actions/locationActions";

const PunchPressGraphSection = ({
  selectedTemplate,
  onChangeParams,
  filter,
  setLoading,
}) => {
  const data = get(selectedTemplate, "graph_report");
  const dispatch = useDispatch();
  const locationId = get(selectedTemplate, "template.location_id");
  const [address, setAddress] = useState();

  const getLocation = (locationId) => {
    setLoading(true);
    dispatch(fetchScopeNodeHierarchy("LOCATION", locationId))
      .then((result) => {
        setAddress(get(result, "name"));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (locationId) {
      getLocation(locationId);
    }
  }, [locationId]);

  return (
    <>
      <GraphHeader
        filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams} />

      <Row id="content-container">
        <GraphGrid
          type="time"
          graphId={1}
          stats={get(data, "on_off_graph", [])}
          label={"On / Off / Idle"}
          statistics={[
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_off_hours") ? round(get(selectedTemplate, "meta.total_off_hours")) : 0
              ),
              label: "Off Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_idle_hours") ? round(get(selectedTemplate, "meta.total_idle_hours")) : 0
              ),
              label: "Idle  Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_working_hours") ? round(get(selectedTemplate, "meta.total_working_hours")) : 0
              ),
              label: "Working Hours",
            },
          ]}
                 filter={filter}
                        selectedTemplate={selectedTemplate}
        />
        <Divider />
        <GraphGrid
          graphId={2}
          type="time"
          label={"Count"}
          stats={sortBy(slice(get(data, "count_graph", [])), "date")}
          statistics={[
            {
              value: get(selectedTemplate, "meta.total_counts") ? round(get(selectedTemplate, "meta.total_counts")) : 0,
              label: "Count",
            },
          ]}
                 filter={filter}
                        selectedTemplate={selectedTemplate}
        />
        <Divider />
        {get(data, "power_consumption_graph") && (
          <GraphGrid
            type="time"
            graphId={3}
            label={"Power Consumption"}
            stats={get(data, "power_consumption_graph", [])}
            statistics={[
              {
                value: `${get(
                  selectedTemplate,
                  "meta.total_power_consumption"
                ) ? round(get(
                  selectedTemplate,
                  "meta.total_power_consumption"
                )) : 0} Kwh`,
                label: "Power Consumption",
              },
            ]}
                   filter={filter}
                        selectedTemplate={selectedTemplate}
          />
        )}
      </Row>
    </>
  );
};

export default PunchPressGraphSection;
